// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FWxV","col":"styles_col__x4GDC"};